import { getAttachedServiceRequests } from '../../../../../api'

export function getAttachedRelatedServiceRequests({ excludeIds, id, params }) {
  const relatedRequestsParams = {
    ...params,
    linked_email_message_uuid: id,
  }

  return getAttachedServiceRequests({
    excludeIds,
    params: relatedRequestsParams,
  })
}
